export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./string-text.vue?vue&type=template&id=5523f2c8"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/string/string-text.vue?vue&type=template&id=5523f2c8
// module id = ABE2
// module chunks = 0